<div class="modal-header">
    <h4 class="modal-title pull-left">{{blockData['title']}}</h4>
</div>
<div class="modal-body">
    <div class="loading-wrap" *ngIf="isLoading">
        <span class="circle1"></span>
        <span class="circle2"></span>
        <span class="circle3"></span>
    </div>
    <form class="no-form-style" *ngIf="form" [formGroup]="form" novalidate>
        <div class="cs-d-flex flex-column">
            <div class="cs-helper-section bg-white cs-border cs-border--bottom">
                <div class="cs-help-text-color p--15">{{blockData['description']}}</div>
            </div>
            <div class="cs-flex-1">
                <div class="cs-block-widget--form cs-d-flex flex-column">
                    <div class="cs-block-widget--form-control">
                        <label class="control-label required_field">Template field to get:</label>
                        <div>
                            <select class="full-width-select2 cs-select2-wfe default-input-height"
                                    (onChange)="onSelectSource($event)"
                                    csSelect2
                                    [dropdownvalue]="inputModel.sourceFieldColName"
                                    [select2Config]="{}">
                                <option value="" translate>Please.Choose</option>
                                <optgroup *ngFor="let group of sourceFields" label="{{group.label}}">
                                    <option *ngFor="let field of group.fields" [value]="field.id">{{field.text}}</option>
                                </optgroup>
                            </select>
                        </div>
                    </div>
                    <div class="cs-block-widget--form-control">
                        <label class="control-label required_field">Custom field to set:</label>
                        <div *ngIf="showTargetSelect">
                            <select class="full-width-select2 cs-select2-wfe default-input-height"
                                    (onChange)="onSelectTarget($event)"
                                    csSelect2
                                    ($instance)="setTargetSelect2Instance($event)"
                                    [dropdownvalue]="form.get('targetFieldColName').value"
                                    [select2Config]="{}">
                                <option value="" translate>Please.Choose</option>
                                <optgroup *ngFor="let group of filteredObjectCustomFields" label="{{group.label}}">
                                    <option *ngFor="let field of group.fields" [value]="field.id">{{field.text}}</option>
                                </optgroup>
                            </select>
                        </div>
                    </div>
                    <div class="cs-block-widget--form-control">
                        <label class="box-checkbox">
                            <span translate>Overwrite existing value</span>
                            <input type="checkbox" formControlName="overrideExisting">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <ng-container *ngIf="!isLoading else footerSection">
        <button *ngIf="showDeleteBtn" class="btn btn-danger btn-medium float-left" (click)="remove()" type="button">Delete </button>
        <button class="btn btn-link" (click)="closeModal()">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="!form.valid || isFormSubmitted" (click)="save()">
            <span *ngIf="!isFormSubmitted" translate>Save</span>
            <span *ngIf="isFormSubmitted" translate>Saving</span>
        </button>
    </ng-container>
</div>

<ng-template #footerSection>
    <button class="btn btn-link" (click)="closeModal()">Cancel</button>
    <button type="submit" class="btn btn-primary" [disabled]="true">
        <span translate>Save</span>
    </button>
</ng-template>
